import React, { Component } from 'react'
import FooterV from './FooterV'
import AuthA from '../../store/actions/AuthA'

import {connect} from 'react-redux'

class FooterC extends Component {

  logout = () => { this.props.authFn.logout()}

  render() {
    return (
      <FooterV
        auth={this.props.auth}
        logout={this.logout}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch) ,
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterC);
